import { Instagram, Linkedin, Facebook } from "lucide-react";
import { LOGO_ICON_URL } from "@/lib/assets";
import { useLanguage } from "@/i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLanguage();
  const go = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    else window.location.href = `/${href}`;
  };

  const navItems = [
    { l: t("footer.leStudio"), h: "#about" },
    { l: t("footer.savoirFaire"), h: "#services" },
    { l: t("footer.galerie"), h: "#gallery" },
    { l: t("footer.temoignages"), h: "#testimonials" },
    { l: t("footer.contact"), h: "#contact" },
  ];

  return (
    <footer data-testid="main-footer" className="relative bg-[#0A1420] border-t border-white/10 pt-24 pb-12">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO_ICON_URL} alt="Medernach Lionel Designer" className="h-12 w-12 object-contain" />
              <span className="font-serif-lux text-xl gold-gradient-text tracking-wide">
                MEDERNACH LIONEL<sup className="text-[0.5em] align-super ml-0.5">™</sup>
              </span>
            </div>
            <p className="mt-6 text-[#A0ABC0] font-light max-w-sm leading-relaxed">
              {t("footer.tagline")}
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-widest text-[#D4AF37] mb-6">{t("footer.navTitle")}</p>
            <ul className="space-y-4">
              {navItems.map((i) => (
                <li key={i.h}>
                  <button
                    onClick={() => go(i.h)}
                    className="text-[#A0ABC0] hover:text-[#D4AF37] transition-colors duration-300"
                  >
                    {i.l}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <p className="text-xs uppercase tracking-widest text-[#D4AF37] mb-6">{t("footer.followTitle")}</p>
            <div className="flex gap-4">
              {[Instagram, Linkedin, Facebook].map((Icon, i) => (
                <a
                  key={Icon.displayName || i}
                  href="#"
                  data-testid={`footer-social-${i}`}
                  className="h-11 w-11 border border-white/15 flex items-center justify-center text-[#A0ABC0] hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors duration-300"
                  aria-label="Réseau social"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <p className="text-[#A0ABC0] text-sm text-center sm:text-left" data-testid="footer-legal">
            DREAMUP-design S.à r.l. · RCS Luxembourg B160763 · 20, rue Notre-Dame, L-2240 Luxembourg
          </p>
          <div className="mt-4 flex flex-col sm:flex-row justify-between items-center gap-4">
            <p className="text-[#A0ABC0] text-sm">
              © {new Date().getFullYear()} MEDERNACH LIONEL DESIGNER™ · DREAMUP-design S.à r.l. — {t("footer.rights")}
            </p>
            <div className="flex items-center gap-5">
              <a
                href="/mentions-legales"
                data-testid="footer-legal-link"
                className="text-[#A0ABC0] hover:text-[#D4AF37] text-xs uppercase tracking-widest transition-colors duration-300"
              >
                {t("footer.legalLink")}
              </a>
              <p className="text-[#A0ABC0]/60 text-xs tracking-widest uppercase">
                {t("footer.motto")}
              </p>
            </div>
          </div>
          <p
            className="mt-5 text-[#A0ABC0]/50 text-xs leading-relaxed max-w-3xl"
            data-testid="footer-ip-notice"
          >
            {t("footer.ipNotice")}
          </p>
        </div>
      </div>
    </footer>
  );
};
